import {observable, action, makeObservable} from "mobx";

class MenuStore {
    isDrawerOpen = false;

    constructor() {
        makeObservable(this, {
            isDrawerOpen: observable,

            setIsDrawerOpen: action,
        })
    }

    initialize() {
        this.isDrawerOpen = false;
    }

    setIsDrawerOpen(open) {
        this.isDrawerOpen = open;
    }
};

export default new MenuStore();
